import React from 'react';
import { Tooltip as Tippy } from 'react-tippy';

type TooltipState = {};

export type TooltipProps = {
    title?: string|React.Component|React.FunctionComponent|JSX.Element|HTMLElement|((props: TooltipProps) => any),
    position?: string,
}

export default class Tooltip extends React.Component<TooltipProps, TooltipState> {
    render() {
        let tooltip = {...this.props};
        delete tooltip.title;
        const html = this.props.title instanceof Function ? this.props.title(tooltip) : this.props.title;
        tooltip = {position: "top"};
        if (html) {
            tooltip.html = html;
        } else {
            tooltip = {};
        }

        const isTippy = !!Object.keys(tooltip).length;

        const Tag = isTippy ? Tippy : "div";

        return (
            <Tag {...(isTippy ? tooltip : {})}>
                {this.props.children}
            </Tag>
        );
    }
}